<template>
  <div class="page question">
    <navigation>常见问题</navigation>
    <img class="pic-banner" src="./images/img_yiwen.png" alt="">
    <img src="./images/img_01.png" alt="" class="pic1">
    <div class="line"></div>
    <img src="./images/img_02.png" alt="" class="pic2">
    <div class="line"></div>
    <img src="./images/img_03.png" alt="" class="pic3">
    <div class="bottom" @click="callService">
      <img src="./images/icon_kefu.png" alt="">
      <span>联系客服</span>
    </div>
  </div>
</template>

<script>
// import { mockHrefJump } from '../../assets/utils'
import wx from 'weixin-webview-jssdk'
export default {
  name: 'question',
  data () {
    return {
      customerServicePhone: '4000100008'
    }
  }, 
  methods: {
    callService () {
      // mockHrefJump(`tel:${this.customerServicePhone}`)
      wx.miniProgram.navigateBack()
      wx.miniProgram.postMessage({ data: { eventType: 'ONELY_NAVIGATE_BACK', eventId: '', url: '', value: null } })
    }
  }
}
</script>

<style scoped lang='less'>
@import "../../assets/less/mixin.less";

    .page.question {
      background-color: #f9f9f9;
      min-height: 100%;
      padding-bottom: 212px;
      position: relative;

      .pic-banner {
          width: 750px;
          margin: 0px;
          height: 250px;
      }
      .line {
        margin: 56px 0px 40px 0px;
        height: 20px;
        background: #F2F2F2;
      }
      .pic1  {
        height: 985px;
        margin: 40px 40px 0px 40px;
      }
      .pic2  {
        height: 874px;
        margin: 40px 40px 0px 40px;
      }
      .pic3 {
        height: 610px;
        margin: 40px 40px 0px 40px;
      }
      .bottom {
        position: absolute;
        background-color: #FFFFFF;
        width: 200px;
        height: 60px;
        bottom: 80px;
        border-radius: 40px;
        border: 1px solid #EEEEEE;
        left: 50%;
        transform: translateX(-50%);
        display: flex;
        flex-direction: row;
        justify-content: space-evenly;
        img {
          margin-top: 14px;
          width: 32px;
          height: 32px;
        }
        span {
          margin-top: 10px;
          margin-left: 8px;
          font-size: 26px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #666666;
          line-height: 37px;
        }
      }
    }
</style>